<template>
	<div class="filters-container">
		<label :for="filter.machineName">
			{{ filter.label }}
		</label>
		<span>
			<select
				v-model="currentValue"
				:id="filter.machineName"
				@change="
					$emit('filtered', {
						key: filter.machineName,
						value: $event.target.value
					})
				"
			>
				<option :value="null">{{ filter.placeholder }}</option>
				<option
					v-for="(value, index) in filter.value"
					:key="index"
					:value="value"
					>{{ value }}
				</option>
			</select>
		</span>
	</div>
</template>
<script>
/* eslint no-console: 0 */
export default {
	name: "input-select",
	props: {
		filter: {}
	},
	data() {
		return {
			currentValue: null
		};
	},
	methods: {
		resetValues() {
			this.currentValue = null;
			this.$emit("filtered", {
				key: this.filter.machineName,
				value: this.currentValue
			});
		}
	}
};
</script>
